<template>
	<li v-loading="loadNode" element-loading-radius="10">
		<a v-bind:class="node.nodeClass">	
			<!--      组织机构内容开始         -->
			<span v-if="node.type!=2" class="company_info">
				<!-- 一级组织机构下拉符号开始 -->
				<span v-if='node.type==1' @click="toggleChild" v-bind:class="[show ? 'company_ico02' : 'company_ico01']"></span>
				<!-- 下拉符号结束 -->
				
				<!-- 二级组织机构下拉符号开始 -->
				<span v-if='node.type==0' @click="toggleChild" v-bind:class="[show ? 'company_ico12' : 'company_ico11']"></span>
				<!-- 下拉符号结束 -->
				<!-- 组织机构名称开始 -->
				<span @click="click" onselectstart="return false"  @dblclick="toggleChild" @mouseover="refreshTime($event)"
					class="company_name" :class="[nodeClickedId===node.id ? 'nodeActive' : '']" ref="node" data-toggle="tooltip-tree" 
					data-placement="bottom" :title="updateInfo">
	        		{{node.name}}
	        		{{searching ? '（' + node.amount + '）': ''}}
				</span>
				<!-- 组织机构名称结束 -->
				<!--下拉框-->
				<em v-if="node.type!=2" class="dropdown">
						<a class="company_menu02" data-toggle="dropdown"></a>
						<ul class="dropdown_menu02 list-group list01">
							<li  @click="refreshNode"><span>刷新</span></li>
						<!--	<li  @click="listNode"><span>一览</span></li>	-->
							<li  v-if="permission.indexOf('vehicleMonitor_panelOpenTrack') == -1" @click="trackNode"><span>轨迹</span></li>
							<!--<li  @click="exportNode"><span>导出</span></li>	-->
						</ul>
				</em>
			</span>
			<!-- 组织机构内容 结束   -->
			
			<!-- 车辆内容开始  -->
			<b class="bg_color" @click.stop="openCarFile"></b>
			<span v-if="node.type==2" class="bg_text" @click.stop="addLocation">
				<i @click.stop="click">
					<span v-if="!checkable" class="sp01" :class="[nodeClickedId===node.id ? 'nodeActive' : '']">
	        			<span v-if="node.vehiclePlateNumber!=''">{{node.vehiclePlateNumber}} </span> {{node.driverName==''?'':'|' + node.driverName}}
					</span>
					<span v-else :class="[nodeClickedId===node.id ? 'nodeActive' : '']">
	        			<span v-if="node.vehiclePlateNumber">{{node.vehiclePlateNumber}}</span> {{node.driverName==''?'':'|' + node.driverName}}
					</span>
					<em v-if="permission.indexOf('vehicleMonitor_panelExpansionPosition') == -1" @click.stop="addTrack" data-toggle="tooltip-tree" data-placement="bottom" title="轨迹">
						<a class="company_playback"></a></em>
					<!--<em @click.stop="addFollow" data-toggle="tooltip-tree" data-placement="bottom" title="关注"><a class="company_attention"></a></em>-->
					<em><input type="checkbox" class="company_check" :checked="node.checked" v-if="checkable" @change.stop="check"/></em> 
				</i>
				<i>
					<!-- 车类型 -->
					<span class="sp02">{{vehicleTypeName}} </span>				
					<!-- 定位图标 --->
					<em @click.stop="addLocation" data-toggle="tooltip-tree" data-placement="bottom" title="定位"><a class="car_location"></a></em>
					<!-- 车主姓名 -showCont3-->
					<em class="em_text"><span class="sp03"> {{node.driverPhone ==''?'':'| ' + node.driverPhone}}</span></em>
				</i>
			</span>
			<!--     车辆内容结束         --> 
        </a>
        <ul v-bind:class="key" v-if="show" class="ul_line" >
	        <items v-for="(child,index) in children" :key="index"
	        	:index="index"
	        	:treeType="treeType"
	        	:node="child"
	        	:checkable="checkable"
	        	:searching="searching"
	        	:searchInput="searchInput"
	        	:searchType="searchType"
	        	:isCarMoved="isCarMoved"
	        	:showCheckbox="showCheckbox"	        	
	        	:nodeClickedId = "nodeClickedId"
	        	v-on:toggleChild="handleToggle"
	        	v-on:refreshNode="handleRefresh"
	        	v-on:srchRefresh="handleSrchRefresh"
	        	v-on:srchToggle="handleSrchToggle"
	        	v-on:addVehicles="handleAddVehicles"
	        	v-on:checkTrace = "handleCheckTrace"
	        	v-on:exportNode = "handleExport"
	        	v-on:addFollow="handleAddFollow"
	        	v-on:addTrack="handleAddTrack"
	        	v-on:addLocation="handleAddLocation"
	        	@click="handleClick"
	        	@check="handleCheck">
	        </items>
	        <div class="loadmore" @click="loadmore" v-if="showLoadmore">
	        	<span>加载更多</span>
	        </div>
        </ul>
    </li>
</template>

<script>
	import {mapState} from 'vuex'
	import { EXPORT_EXCEPTION } from 'static/message'
	import {treeMixin} from './mixin'
	import {getNameMixin} from 'util/rescueUtil'
	export default{
        name:"items",
        mixins:[treeMixin,getNameMixin],
		props: {
			node: {
				default() {
					return {};
				}
			},
			checkable:{ //控制车辆分支复选框是否可用
				type:Boolean
			},
			curTreeIndex:{
				type:Number
			},
			nodeClickedId:{
				type:Number
			},
			searching:{
				type:Boolean
			},
			isCarMoved:{
				type:Boolean
			},
			index: {
				type: Number
			},
			treeType:{
				type:Number
			},
			searchInput:{
				type:String
			},
			searchType:{
				type:String				
			},
			showCheckbox: {
				type: Boolean
           }
		},
		data(){
			return{
				permission:this.$store.state.permission.permission["vehicleMonitor"]?this.$store.state.permission.permission["vehicleMonitor"]:[],
				show: this.node.isShow,									//是否显示子节点
				key:Math.random().toString().substring(2,6),
				checkCount:0,
				updateInfo:"",
				refreshDate:'',
				loadNode:false,
				currIndex:100,				// 若子节点的数量大于100，则首先加载前100个，待点击加载更多时，加载下100个
				childrenNodes:[],			// 所有的子节点
				children:[],				// 当前显示的子节点
				showLoadmore:false
			}
		},
		computed:{
			...mapState({
				groupId:state=>state.user.groupid,
				mountD:state=>state.monitor.mountD
			})
		},
		watch: {
			'node.isShow'(val){
				this.show = val;
			},
			curTreeIndex:function(val){
				this.show = false
			},
			treeType:function(val){
				this.show = false;
			},
			isCarMoved:function(val){
				if(val){
					this.show = false;
				}
			},
			checkable(val){
				if(val){
					this.node.checked = false 
					//取消所有车辆选中状态
					this.$store.dispatch('clearChecked')
					this.checkCount = 0
				}
			},
			node(val){
				this.children = val.children;
			}
		},
		updated(){ 
			if(this.node.id == this.groupId){
				this.show = true;
			}  
		},
		destroyed(){
			$('[data-toggle="tooltip-tree"]').tooltip('hide')
		},
		mounted: function(){ 
			if(this.node.id == this.groupId){
				this.show = true;
			}
			this.children = this.node.children;
			$('[data-toggle="tooltip-tree"]').tooltip({delay:{show:200,hide:100}});
		},
		methods:{
			toggleChild(){//展开或收起子节点
				const self = this;
				const id = this.groupId;
				if(id == this.node.id){//根节点情况下不用调getSubTree()方法
					this.show = !this.show
					return 
				}
				if(!this.searching){//查询中
					if(this.searchType == 0){//查车辆
						
						if(this.show){
							this.show = !this.show
						}else{
							let p1 = this.getSubTree();
							p1.then(function(data){
								self.show = !self.show
							})
						}
						this.$emit('toggleChild',this.node)
					}else{//查分支
						let p1 = this.getSubTree();
						p1.then(function(data){
							self.show = !self.show
						})
						this.$emit('toggleChild',this.node)
					}
				}else{//取消查询
					if(this.show){
						this.show = !this.show
					}else{
						let p1 = this.getSubTree();
						p1.then(function(data){
							self.show = !self.show
						})
					}
					this.$emit('toggleChild',this.node)
				}
        	},
        	loadmore(){
        		let endIndex = this.currIndex + 100;
        		if(endIndex > this.childrenNodes.length){
        			endIndex = this.childrenNodes.length;
        			this.showLoadmore = false;
        		}
        		for(let i = this.currIndex; i < endIndex; i++){
        			if(this.childrenNodes[i].type==2){
						this.childrenNodes[i].nodeClass = 'leaf '  + this.getStatusByInfo(this.childrenNodes[i]);////添加车辆分支的class
					}
					this.children.push(this.childrenNodes[i])
        		}
        		this.currIndex = endIndex;
        	},
        	handleSrchToggle(obj){
        		this.$emit('srchToggle',obj)
        	},
        	handleToggle(obj){
        		this.$emit('toggleChild',obj)
        	},
        	getSubTree(){//获取子分支树内容
        		this.loadNode = true
        		const appendParam = {
					groupId:this.node.id,
					isCustomerType:this.node.type==0?false:true,
					treeType:this.treeType + ''
				}
        		const self = this;
        		let p = new Promise(function(resolve,reject){
				//	self.$http.get(process.env.API_ROOT + '/monitor/tree/groups/vehicles',{params:appendParam})  //rescue-api/monitor/rescues/vehicles/tree
					self.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/monitor/rescues/vehicles/tree',{params:appendParam})
					.then((response) => {
						if(response.body.success){
							self.refreshDate = new Date();
							self.loadNode = false
							if(!response.body.data) return;
							let treeTmp2 = response.body.data;
							self.childrenNodes = response.body.data;
							let length = self.childrenNodes.length > 100 ? 100 : self.childrenNodes.length;
							self.children = []
							self.node.amount = treeTmp2[0].amount
							for(let i = 1; i < length ; i ++){
								if(treeTmp2[i].type==2){
									treeTmp2[i].nodeClass = 'leaf '  + self.getStatusByInfo(treeTmp2[i]);////添加车辆分支的class
								}
								self.children.push(treeTmp2[i])
							}
							self.showLoadmore = (self.childrenNodes.length > 100) ? true : false;
							//取消所有车辆选中状态
							self.$store.dispatch('clearChecked')
							self.checkCount = 0
							resolve(self.node)
						}else{
							self.loadNode = false
							self.$store.dispatch('tipModalShow',response.body.message)
						}
					},(response)=>{
						self.loadNode = false
						self.$store.dispatch('tipModalShow',response.body.message)
					})
					.catch((response)=>{
						self.loadNode = false
						self.$store.dispatch('tipModalShow','请求数据异常')
					})
				})
        		return p;
        	},
        	click: function(){//点击树节点
        		let obj = {
        			cNode:this.node,
        			pN:this.$parent.node,
        			index:this.index
        		}
        		this.$emit('click',obj);
        	},
        	handleClick: function(obj){
        		this.$emit('click',obj);
        	},
			refreshNode(){//企业分支点刷新
				if(!this.searching){//查询中
					if(this.searchType=='0'){
						this.$emit('srchRefresh')
					}else{
						this.refreshDate = new Date();
						const id = this.groupId;
						let p1 = this.getSubTree();
						const self = this;
						p1.then(function(data){
							self.show = true
						})
						this.$emit('refreshNode',this.node)
					}
				}else{//取消查询
					this.refreshDate = new Date();
					const id = this.groupId;
					let p1 = this.getSubTree();
					const self = this;
					p1.then(function(data){
						self.show = true
						
					})
					this.$emit('refreshNode',this.node)
				}
			},
			handleSrchRefresh(){
				this.$emit('srchRefresh')
			},
			handleRefresh(obj){
				this.$emit('refreshNode',obj)
			},
			listNode(){//企业分支点一览-》将车辆分支添加到底部车辆一览面板
			//process.env.API_ROOT + '/monitor/vehicle/vehicles/group?groupId=' + this.node.id
			//process.env.API_ROOT + '/monitor/vehicle/vehicles/group?groupId=' + this.node.id + '&treeType=' + this.treeType + '&vehicleParam=' + this.searchInput
				let listParam = {//车辆查询或取消查询
					groupId:this.node.id,
					treeType:this.treeType,
					vehicleParam:this.searchInput
				}
				if(this.searchType=='1'){//分支查询
					listParam = {
						groupId:this.node.id,
						treeType:this.treeType,
						vehicleParam:''
					}
				}
				this.$http.post(process.env.API_ROOT + '/monitor/vehicle/vehicles/group?groupId=' + listParam.groupId + '&treeType=' + listParam.treeType + '&vehicleParam=' + listParam.vehicleParam)
				.then((response) => {
					if(response.body.success){
						const param = {
								page_index:1,
								searchType:0,
								sort_asc:'',
								sort_desc:''
							}
						
						this.$store.dispatch('getVehicleList',param)
					}else{
						this.$store.dispatch('tipModalShow',response.body.message)
					}
				},(response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
				.catch((response)=>{
					
				})
				this.$emit('addVehicles');
			},
			handleAddVehicles(id){
				this.$emit('addVehicles');
			},
			trackNode(){//企业分支点轨迹-》添加到轨迹回放页面左侧的轨迹队列
				//1,切换到轨迹回放tab
				const obj = {
					name:'救援车辆轨迹', 
					code:'vehicleTrace',
					id:'PageVehicleTrace',
					route:'/indexhome/vehicleTrace',
					No:'vehicleTrace'
				}
				this.$router.push(obj.route);
				this.$store.dispatch('addTab',obj);
				let param = {//车辆查询或取消查询
					groupId:this.node.id,
					treeType:this.treeType,
					vehicleParam:this.searchInput
				}
				if(this.searchType=='1'){//分支查询
					 param = {
						groupId:this.node.id,
						treeType:this.treeType,
						vehicleParam:''
					}
				}
				const self = this;
				this.$store.dispatch('allTrackList',param).then(()=>{
					this.$store.dispatch('getTraceList',1)
				})
				this.$emit('checkTrace')
			},
			handleCheckTrace(){
				this.$emit('checkTrace')
			},
			exportNode(){//企业分支点导出
				let obj = {
					groupId:this.node.id,
					treeType:this.treeType,
					vehicleParam:this.searchInput
				}
				if(this.searchType=='1'){//分支查询
					 obj = {
						groupId:this.node.id,
						treeType:this.treeType,
						vehicleParam:''
					}
				}
				this.$store.dispatch('loadTreeList',true)
				this.$http.get(process.env.API_ROOT + '/monitor/vehicle/vehicles/' + obj.groupId + '/export?treeType=' + obj.treeType + '&vehicleParam=' + obj.vehicleParam)
				.then((res)=>{
					this.$store.dispatch('loadTreeList',false)
					let str = res.body.data
					var path = process.env.EXPORT_PATH;
					var api = process.env.API_ROOT;
					var fileName = path  + api + '/noauth/export?url=' + str;
					//var fileName = 'http://192.168.1.87:8888/noauth/export?url=' + str;
//					var fileName = 'http://c.didigps.com/api/noauth/export?url=' + str;
    				var elemIF = document.createElement("iframe");   
		            elemIF.src = fileName;   
		            elemIF.style.display = "none";   
		            document.body.appendChild(elemIF);  
				},(res)=>{
					this.$store.dispatch('loadTreeList',false)
					this.$store.dispatch('tipModalShow',res.body.message)
				})
				.catch((res)=>{
					this.$store.dispatch('loadTreeList',false)
					this.$store.dispatch('tipModalShow',EXPORT_EXCEPTION)
				})
				this.$emit('exportNode')
			},
			handleExport(){
				this.$emit('exportNode')
			},
			addFollow(){//车辆分支-》添加到关注一览面板
				const obj = {
					id:this.node.id,
					type:0
				}
				this.$store.dispatch('followModalShow',obj)
				
			//	this.$store.dispatch('getFollowList',obj)//显示弹框的同时获取原有关注面板（不含车辆）的信息
				this.$emit('addFollow')
			},
			handleAddFollow(){
				this.$emit('addFollow')
			},
			addTrack(){//车辆分支-》打开轨迹回放，追加到轨迹队列
				//1,切换到轨迹回放tab
				const obj = {
					name:'车辆轨迹回放',
					code:'vehicleTrace',
					id:'PageVehicleTrace',
					route:'/indexhome/vehicleTrace',
					No:'vehicleTrace'
				}
				this.$router.push(obj.route);
				this.$store.dispatch('addTab',obj);
				//2,追加到轨迹队列
				let arr = []
				arr.push(this.node.id)
				const param = {
					vehicleIds:arr,
					type:4
				}
				this.$store.dispatch('addTrackList',param).then(()=>{
					this.$store.dispatch('getTraceList',1)
				})
				this.$emit('addTrack')
			},
			handleAddTrack(id){
				this.$emit('addTrack')
			},
			addLocation(){//车辆分支-》添加到车辆一览面板并且在地图上显示定位  
				let vId = this.node.id  
				this.$store.dispatch('locateOne',vId)
				this.$emit('addLocation')
			},
			handleAddLocation(obj){
				this.$emit('addLocation')
			},
			addOneToList(param1){
				//'/monitor/vehicle/vehicles/',param1
				//'/monitor/vehicle/vehicles/?vehicleIds=' + param1.vehicleIds
				this.$http.post(process.env.API_ROOT + '/monitor/vehicle/vehicles/',param1)
				.then((response) => {
					if(response.body.success){
						const param = {
							page_index:1,
							searchType:0,
							sort_asc:'',
							sort_desc:''
						}
						this.$store.dispatch('getVehicleList',param)
					}else{
						this.$store.dispatch('tipModalShow',response.body.message)
					}
				},(response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
				.catch((response)=>{
					
				})
			},
			refreshTime(e){//鼠标滑过显示组织机构更新于多少分钟前 
				let tDiff = 0
				if(this.refreshDate === ''){
					tDiff = new Date().getTime() - this.mountD.getTime()
				}else{
					tDiff = new Date().getTime() - this.refreshDate.getTime()
				}
				let sDiff = tDiff / 1000
				let h = sDiff / 3600 < 1 ? '0' : parseInt(sDiff / 3600);
				let min = parseInt(sDiff % 3600 / 60)
				let sec = parseInt(sDiff % 3600 % 60)
				let updateInfo =`${this.node.name}(${this.node.amount})更新于${h}时${min}分${sec}秒 前`
//				$(e.target);
				$(e.target).attr('title', updateInfo).tooltip('fixTitle').tooltip('show').tooltip({delay:{ show: 500, hide: 100 }});
			},
			getCarDetail(id){
				const that = this;
				let pro = new Promise(function(resolve,reject){
					that.$http.get(process.env.API_ROOT + '/vehicle/vehicles/' +  id)
	        		.then((res)=>{
	        			if(res.body.success){
	        				let obj = res.body.data
	        				resolve(obj)
	        			}
	        		},(res)=>{
	        			that.$store.dispatch('tipModalShow',res.body.message)
	        		})
	        		.catch((res)=>{
	        			that.$store.dispatch('tipModalShow',res.body.message)
	        		})
				})
        		return pro
			},
        	openCarFile(){//点击打开车辆详情标签
        		const that = this
        		let pro = this.getCarDetail(that.node.id)
        		pro.then(function(res){
        			const vInfo = res;
        			if(vInfo.plateNumber){
        					const obj = {
								name:vInfo.plateNumber,
								id:'PageCarFileDetail',
								route:'/indexhome/carFileDetail' + vInfo.vehicleId,
								No:'file' + vInfo.vehicleId,
								params:{id: vInfo.vehicleId}
							}
							that.$router.push({path:'/indexhome/carFileDetail' + vInfo.vehicleId,query:{id: vInfo.vehicleId}});
							that.$store.dispatch('addTab',obj);
        			}else{
							const obj = {
								name:"VE" + vInfo.vehicleId,
								id:'PageCarFileDetail',
								route:'/indexhome/carFileDetail' + vInfo.vehicleId,
								No:'file' + vInfo.vehicleId,
								params:{id: vInfo.vehicleId}
							}
							that.$router.push({path:'/indexhome/carFileDetail' + vInfo.vehicleId,query:{id: vInfo.vehicleId}});
							that.$store.dispatch('addTab',obj);
					}
        		})
        	},
        	check: function(){
        		this.checkCount++;
        		if(this.checkCount%2!=0){
        			this.node.checked=true;
        		}else{
        			this.node.checked=false;
        		}
				this.$emit('check',this.node,this.$parent.node);
        	},
        	handleCheck: function(obj,pNode){
        		this.$emit('check',obj,pNode);
        	}
		}
	}
</script>

<style scoped>
	.nodeActive{color:#46AC89;}
	.loadmore{
	    text-align: center;
		padding: 13px 0px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// TreeNode.vue?e9f4e47e